import React from 'react';
import { DiffValue } from './DiffValue';

export const SiteDiffValue = ({ value, diff }) => (
    <DiffValue value={value} diff={diff} />
);
